import { mapGetters } from 'vuex';

export default {
  props: ['sectionTitle', 'tabsSize'],
  data() {
    return { tabs: [], windowWidth: window.innerWidth };
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  created() {
    this.tabs = this.$children;
  },
  computed: {
    ...mapGetters('product', ['productTitle']),
  },
  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach((tab, index) => {
        tab.isActive = tab.index === selectedTab.index;
      });
      this.handleTracking();
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    handleTracking() {
      window.dataLayer.push({
        event: 'product_module_interaction',
        module_name: 'how to module',
        product_name: this.productTitle,
        click_action: 'click',
        shopify_module_name: 'tabs'
      });
    },
  },
  template: `
      <div class="how-to__tabs">
        <div class="how-to__steps-wrapper">
          <h3 class="section-heading how-to__title" v-text="sectionTitle"></h3>
          <div class="how-to__steps" v-if="tabsSize > 1">
            <button v-for="(tab, index) in tabs" :class="[{ 'active': tab.isActive }, 'how-to__step']" @click="selectTab(tab)" :aria-label=tab.name :aria-current="tab.isActive ? 'true' : 'false'">
              <span class="how-to__step-number">{{index + 1}}</span>
              <span v-show="windowWidth >= 768">{{ tab.name }}</span>
            </button>
          </div>
        </div>

        <div class="tabs-details how-to__step-content">
            <slot></slot>
        </div>
      </div>
    `,
};
